/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import {
  Alert, Row, Card, Col, CardHeader, CardBody, Table, Badge, Button,
} from 'reactstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
import PlusCircleIcon from 'mdi-react/PlusCircleIcon';
import ModalContact from './ModalContact';

const idLocale = require('moment/locale/fr');

moment.locale('fr', idLocale);

const keyContacts = [
  {
    role: {
      value: 'accountant',
      label: 'Comptable',
    },
  },
  {
    role: {
      value: 'banker',
      label: 'Banquier',
    },
  },
  {
    role: {
      value: 'lawyer',
      label: 'Avocat',
    },
  },
  {
    role: {
      value: 'other',
      label: 'Autre',
    },
  },
];

const keyContactsEstate = [
  {
    role: {
      value: 'trustee',
      label: 'Syndic',
    },
  },
  {
    role: {
      value: 'agency',
      label: 'Agence',
    },
  },
  {
    role: {
      value: 'banker',
      label: 'Banquier',
    },
  },
  {
    role: {
      value: 'other',
      label: 'Autre',
    },
  },
];

// const getListKeys = (contacts_pro, assetId) => {
//   const endList = [];
//   [...keyContacts].forEach((e) => {
//     const isAdded = contacts_pro.find(c => c.linked_asset_id === assetId && c.role.value === e.role.value);
//     let dataToAdd = e;
//     if (isAdded) {
//       dataToAdd = { ...isAdded };
//     }
//     endList.push(dataToAdd);
//   });
//   console.log('end list: ', endList);
//   return endList;
// };

const Contacts = (props) => {
  const {
    contacts_pro, createContact, isLoading, deleteContact, data, isViewOnly,
  } = props;
  const { category, _id } = data;
  const [isModal, setIsModal] = React.useState(false);
  const [contactData, setContactData] = React.useState({});
  // const updatedList = getListKeys(contacts_pro, assetId);

  const addContact = (e, isEditing = false) => {
    if (isLoading) return;
    if (!e.role) e.role = { value: 'other', label: '' };
    e.isEditing = isEditing;
    setIsModal(true);
    setContactData(e);
  };

  const toggleModal = () => {
    setIsModal(!isModal);
  };

  const isCompany = category === 'company';
  const listContacts = isCompany ? keyContacts : keyContactsEstate;
  const listContactsPro = contacts_pro.filter(e => e.linked_asset_id === _id);

    return (
      <div className="dashboard">
        {
          !isViewOnly && (
            <Alert color="info">
              Vous pouvez renseigner ici toutes les personnes ou institutions qui seraient utiles à votre succession.
              <br />Qu'il s'agisse de votre {isCompany ? 'comptable' : 'syndic'}, votre gestionnaire de patrimoine ou votre banquier, ils sauront être une aide précieuse pour vos proches le moment venu.
            </Alert>
          )
        }
        {
          (isViewOnly && listContactsPro.length === 0) ? (
            <div>
              Aucun contact renseigné.
            </div>
          ) : (
            <Card className="light-border mt-20 pb-0">
              <CardHeader className="white-background fs16 d-flex align-items-center h-space-between">
                <h4 className="bold-text">Contacts {isCompany ? 'professionnels' : 'utiles'}</h4>
                {
                  !isViewOnly && listContactsPro.length > 0 && (
                    <Button size="sm" className="mb-0" color="official" onClick={addContact}>
                      Ajouter
                    </Button>
                  )
                }
              </CardHeader>
              <CardBody className={`${listContactsPro.length > 0 ? 'p-0' : ''}`}>
                {
                  listContactsPro.length > 0 ? (
                    <Table responsive striped className="dashboard__table-orders">
                      <thead>
                        <tr>
                          <th>Nom</th>
                          <th>Email</th>
                          <th>Téléphone</th>
                          <th>Cabinet</th>
                          <th>Rôle</th>
                        </tr>
                      </thead>
                      <tbody>
                        {listContactsPro.map(item => (
                          <tr key={item._id} onClick={() => addContact(item, true)}>
                            <td>
                              {item.full_name}
                            </td>
                            {
                              item.email ? (
                                <td className="fs12 fw-300 coolGrey-text">
                                  {item.email}
                                </td>
                              ) : (
                                <td>
                                  <Badge color="warning">Non renseigné</Badge>
                                </td>
                              )
                            }
                            {
                              item.phone ? (
                                <td className="fs12 fw-300 coolGrey-text">
                                  {item.phone}
                                </td>
                              ) : (
                                <td>
                                  <Badge color="warning">Non renseigné</Badge>
                                </td>
                              )
                            }
                            {
                              item.company ? (
                                <td className="fs12 fw-300 coolGrey-text">
                                  {item.company}
                                </td>
                              ) : (
                                <td>
                                  <Badge color="warning">Non renseigné</Badge>
                                </td>
                              )
                            }
                            <td>
                              {item.role && item.role.label}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  ) : (
                    <div className="d-flex align-items-center justify-content-center">
                      <Row className="dashboard_value_row fullWidth">
                        {
                          listContacts.map(e => (
                            <Col xl="3" key={e.role.value}>
                              {
                                e._id ? (
                                  <div style={{ minHeight: 100 }} onClick={() => addContact(e, true)} className={`dashboard_case_value text-center ${isLoading ? 'disabled' : ''}`}>
                                    <p>
                                      {e.full_name}
                                    </p>
                                    <p>
                                      {e.company}
                                    </p>
                                    <div className="dashboard_value_description fw-500">
                                      {e.role.label}
                                    </div>
                                  </div>
                                ) : (
                                  <div onClick={() => addContact(e)} className={`dashboard_case_value text-center ${isLoading ? 'disabled' : ''}`}>
                                    <div className="dashboard_value_number text-bigger text-center p-6">
                                      <PlusCircleIcon size="50" color="#eba64c" />
                                    </div>
                                    <div className="dashboard_value_description fw-500">
                                      {e.role.label}
                                    </div>
                                  </div>
                                )
                              }
                            </Col>
                          ))
                        }
                      </Row>
                    </div>
                  )
                }
              </CardBody>
            </Card>
          )
        }
        {isModal && <ModalContact isViewOnly={isViewOnly} isModal={isModal} toggle={toggleModal} assetData={data} data={contactData} createContact={createContact} deleteContact={deleteContact} />}
      </div>
    );
};

Contacts.propTypes = {
  contacts_pro: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  createContact: PropTypes.func,
  deleteContact: PropTypes.func,
  isLoading: PropTypes.bool,
  data: PropTypes.shape({}).isRequired,
  isViewOnly: PropTypes.bool.isRequired,
};

Contacts.defaultProps = {
  createContact: () => {},
  deleteContact: () => {},
  isLoading: false,
};

export default Contacts;
